<template>
  <v-card>
    <v-card-title v-if="options.title">
      <span class="headline">{{ options.title }}</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <ValidationObserver
        ref="form"
        tag="form"
        @submit.prevent="save"
      >
        <ValidationProvider
            vid="is_sync"
            :name="$t('fields.sync_warehouse').toLowerCase()"
            v-slot="{ errors }"
        >
            <v-checkbox
              v-model="form.is_sync"
              :label="$t('fields.sync_warehouse')"
              :value="1"
              hide-details
            ></v-checkbox>
        </ValidationProvider>
        <ValidationProvider
            rules="required"
            vid="isbn"
            :name="$t('fields.isbn').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-text-field
            v-model="form.isbn"
            :counter="13"
            :label="$t('fields.isbn')"
            :error-messages="errors"
            id="isbn"
            ref="isbn"
          ></v-text-field>
        </ValidationProvider>

        <ValidationProvider
            vid="internal_code"
            :name="$t('fields.internal_code').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-text-field
            v-model="form.internal_code"
            :counter="13"
            :label="$t('fields.internal_code')"
            :error-messages="errors"
            id="internal_code"
            ref="internal_code"
          ></v-text-field>
        </ValidationProvider>

        <ValidationProvider
            rules="required"
            vid="author"
            :name="$t('fields.author').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-text-field
            v-model=" form.author"
            :counter="255"
            :label="$t('fields.author')"
            :error-messages="errors"
          ></v-text-field>
        </ValidationProvider>

        <ValidationProvider
            rules="required"
            vid="title"
            :name="$t('fields.title').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-text-field
            v-model=" form.title"
            :counter="255"
            :label="$t('fields.title')"
            :error-messages="errors"
          ></v-text-field>
        </ValidationProvider>

        <v-row>
          <v-col cols="4">
            <ValidationProvider
                rules="required"
                vid="volume"
                :name="$t('fields.volume').toLowerCase()"
                v-slot="{ errors }"
            >
              <v-text-field
                v-model=" form.volume"
                :label="$t('fields.volume')"
                :error-messages="errors"
              ></v-text-field>
            </ValidationProvider>
          </v-col>
          <v-col cols="4">
            <ValidationProvider
                rules="required"
                vid="type_id"
                :name="$t('fields.type').toLowerCase()"
                v-slot="{ errors }"
            >
              <v-select
                :items="bookTypes"
                v-model="form.type_id"
                :label="$t('fields.type')"
                :error-messages="errors"
              >
              </v-select>
            </ValidationProvider>
          </v-col>
          <v-col cols="4">
            <ValidationProvider
                rules="required"
                vid="price"
                :name="$t('fields.price').toLowerCase()"
                v-slot="{ errors }"
            >
            <v-text-field
                v-model="form.price"
                :label="$t('fields.price')"
                :error-messages="errors"
                @blur="normalizePrice"
              ></v-text-field>
            </ValidationProvider>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <ValidationProvider
                rules="required"
                vid="editor_id"
                :name="$t('fields.editors').toLowerCase()"
                v-slot="{ errors }"
            >
              <v-select
                :items="editors"
                v-model="form.editor_id"
                item-text="name"
                item-value="id"
                :label="$t('fields.editors')"
                :error-messages="errors"
              >
              </v-select>
            </ValidationProvider>
          </v-col>
          <v-col cols="4">
            <ValidationProvider
                rules="required|numeric"
                vid="pubblication_year"
                :name="$t('fields.pubblication_year').toLowerCase()"
                v-slot="{ errors }"
            >
              <v-text-field
                v-model=" form.pubblication_year"
                :label="$t('fields.pubblication_year')"
                :error-messages="errors"
              ></v-text-field>
            </ValidationProvider>
          </v-col>
          <v-col cols="4">
            <ValidationProvider
                vid="subject_id"
                :name="$t('fields.subjects').toLowerCase()"
                v-slot="{ errors }"
            >
              <v-select
                :items="subjects"
                v-model="form.subject_id"
                clearable
                item-text="name"
                item-value="id"
                :label="$t('fields.subjects')"
                :error-messages="errors"
              >
              </v-select>
            </ValidationProvider>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <v-checkbox
              v-model="form.is_primary"
              :label="$t('fields.primary_school')"
              :value="1"
              hide-details
            ></v-checkbox>
          </v-col>

          <v-col cols="4">
            <v-checkbox
              v-model="form.is_secondary"
              :label="$t('fields.secondary_school')"
              :value="1"
              hide-details
            ></v-checkbox>
          </v-col>

          <v-col cols="4">
            <v-checkbox
              v-model="form.is_traceable"
              :label="$t('fields.traceable')"
              :value="1"
              hide-details
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row
          v-if="!Object.keys(book).length"
        >
            <v-col cols="4">
                <ValidationProvider
                    vid="warehouse_id"
                    :name="$t('fields.warehouse').toLowerCase()"
                    v-slot="{ errors }"
                >
                  <v-select
                    :items="warehouseOptions"
                    v-model="form.warehouse_id"
                    item-text="name"
                    item-value="id"
                    :label="$t('fields.warehouse')"
                    :error-messages="errors"
                  >
                  </v-select>
                </ValidationProvider>
            </v-col>
            <v-col cols="4">
                <ValidationProvider
                    :rules="form.warehouse_id ? 'required' : ''"
                    vid="qty"
                    :name="$t('fields.quantity').toLowerCase()"
                    v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="form.qty"
                    :label="$t('fields.quantity')"
                    :disabled="!form.warehouse_id"
                    :error-messages="errors"
                  ></v-text-field>
                </ValidationProvider>
            </v-col>
            <v-col cols="4">
                <ValidationProvider
                    vid="warehouse_location"
                    :name="$t('fields.warehouse_location').toLowerCase()"
                    v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="form.warehouse_location"
                    :label="$t('fields.warehouse_location')"
                    :disabled="!form.warehouse_id"
                    :error-messages="errors"
                  ></v-text-field>
                </ValidationProvider>
            </v-col>

        </v-row>
        <v-row
          v-else
        >
          <v-col
            cols="12"
          >
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">{{ $t('fields.warehouse') }}</th>
                  <th class="text-left">{{ $t('fields.quantity') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in form.warehousesProduct" :key="item.id">
                  <td>{{ item.name }}</td>
                  <td>{{ item.pivot.qty }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          </v-col>
        </v-row>
    </ValidationObserver>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="save" color="primary">{{ $t('SAVE') }}</v-btn>
      <v-btn @click="cancel">{{ $t('CANCEL') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
  import { mapActions, mapState } from 'vuex';

  import { editorsService } from '../../../utils/services/editors.service';
  import { subjectsService } from '../../../utils/services/subjects.service';
  import { booksService } from '../../../utils/services/books.service';
  import { warehousesService } from '../../../utils/services/warehouses.service';

  export default {
    name: 'BookModal',
    data() {
      return {
        stored: null,
        book: {},
        editors: [],
        subjects: [],
        warehouses: [],
        bookTypes: [],
        form: {
          id: 0,
          editor_id: null,
          subject_id: null,
          type_id: null,
          warehouse_id: null,
          isbn: 97888,
          internal_code: null,
          title: null,
          author: null,
          volume: null,
          price: 0,
          pubblication_year: null,
          qty: 0,
          warehouse_location: null,
          is_primary: 0,
          is_secondary: 0,
          is_traceable: 0,
          is_sync: 1,
        },
        warehousesProduct: [],
        loading: false,
        errors: {},
      };
    },
    computed: {
      ...mapState('modal', ['options', 'data']),
      getDefaultWarehouse() {
        return this.warehouses.filter(x => x.is_default === 1);
      },
      warehouseOptions() {
        return [
          { id: null, name: this.$t('fields.catalog_only') || 'Solo catalogo (nessun magazzino)' },
          ...this.getDefaultWarehouse,
        ];
      },
    },
    methods: {
      ...mapActions('alert', ['showToast']),
      ...mapActions('modal', ['hideModal', 'loadingModal']),
      async save() {
        this.normalizePrice();
        const isValid = await this.$refs.form.validate();
        if (isValid) {
            if (this.options.onSave) {
              this.loadingModal(true);
              this.options.onSave(
                this.form,
                this.$refs.form,
              )
              .then(() => {
                  this.loadingModal(false);
              });
            }
        }
      },
      cancel() {
        this.hideModal({});
      },
      normalizePrice() {
        if (this.form.price === null || this.form.price === '') {
          return;
        }
        const normalized = String(this.form.price).replace(',', '.').trim();
        if (normalized !== '' && !isNaN(Number(normalized))) {
          this.form.price = normalized;
        }
      },
      fetchEditors() {
        return editorsService.index({
          pagination: 0,
          filters: {
            sortBy: ['name'],
            sortDesc: ['true'],
          },
        })
        .then(response => {
            this.editors = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },

      fetchSubjects() {
        return subjectsService.index({
          pagination: 0,
          filters: {
            sortBy: ['name'],
            sortDesc: ['true'],
          },
        })
        .then(response => {
            this.subjects = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },

      fetchWarehouses() {
        return warehousesService.index()
        .then(response => {
            this.warehouses = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },

      fetchBook(id) {
        return booksService.get(id)
        .then(response => {
            this.book = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },

      fetchBookType() {
        return booksService.getType()
        .then(response => {
            this.bookTypes = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },
    },
    async created() {
      this.loadingModal(true);

      await this.fetchEditors();
      await this.fetchSubjects();

      await this.fetchBookType();

      if (this.data.stored.id) {
        await this.fetchBook(this.data.stored.id);
        this.form = {
          id: this.data.stored.id,
          editor_id: this.book.editor_id,
          subject_id: this.book.subject_id,
          type_id: this.book.type_id,
          isbn: this.book.isbn,
          internal_code: this.book.internal_code,
          title: this.book.title,
          author: this.book.author,
          volume: this.book.volume,
          price: (this.book.price) ? parseFloat(this.book.price) : 0,
          pubblication_year: this.book.pubblication_year,
          is_primary: this.book.options.is_primary ? 1 : 0,
          is_secondary: this.book.options.is_secondary ? 1 : 0,
          is_traceable: this.book.options.is_traceable ? 1 : 0,
          warehousesProduct: this.book.warehouses,
          is_sync: 1,
        };
      } else {
        await this.fetchWarehouses();
        this.form.warehouse_id = (this.getDefaultWarehouse.length)
          ? this.getDefaultWarehouse[0].id
          : null;
      }
      this.loadingModal(false);

      setTimeout(() => {
        document.getElementById('isbn').focus();
      }, 500);
    },

  };
</script>
